"use client";

import { usePathname } from "next/navigation";
import {
  CalendarCheck,
  LayoutDashboard,
  Store,
  Timer,
  Warehouse,
} from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import React from "react";
import { Link } from "../i18n/navigation";
import { mobilePlatformPageId } from "./mobile-platform-pages";

export function PlatformBottomNav() {
  const locale = useLocale();
  const pathname = usePathname();
  const t = useTranslations("Common");

  const activePageId = mobilePlatformPageId(pathname, locale);

  const tabs = [
    {
      href: "/dashboard",
      label: t("dashboard"),
      accessibleLabel: t("dashboard"),
      icon: LayoutDashboard,
      active: activePageId === "dashboard",
    },
    {
      href: "/stopwatch",
      label: t("stopwatch"),
      accessibleLabel: t("stopwatch"),
      icon: Timer,
      active: activePageId === "stopwatch",
    },
    {
      href: "/planner",
      label: t("planner"),
      accessibleLabel: t("planner"),
      icon: CalendarCheck,
      active: activePageId === "planner",
    },
    {
      href: "/marketplace",
      label: t("marketplaceShort"),
      accessibleLabel: t("marketplace"),
      icon: Store,
      active: activePageId === "marketplace",
    },
    {
      href: "/stable",
      label: t("stable"),
      accessibleLabel: t("stable"),
      icon: Warehouse,
      active: activePageId === "stable",
    },
  ];

  return (
    <nav
      aria-label={t("mobileNavigation")}
      data-platform-bottom-nav=""
      className="absolute inset-x-0 bottom-0 z-[var(--z-index-sticky)] border-t border-border-subtle bg-surface pb-[var(--mobile-bottom-navigation-bottom-spacing)] md:hidden"
    >
      <div className="grid h-[var(--mobile-bottom-navigation-height)] grid-cols-5 items-stretch">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <Link
              key={tab.href}
              href={tab.href}
              aria-label={tab.accessibleLabel}
              aria-current={tab.active ? "page" : undefined}
              className={`flex min-h-[48px] flex-col items-center justify-center gap-[4px] border-t-2 px-[4px] py-[4px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-inset ${
                tab.active
                  ? "border-brand font-bold text-brand"
                  : "border-transparent text-secondary hover:text-primary"
              }`}
            >
              <Icon className="size-[20px] shrink-0" aria-hidden="true" />
              <span className="max-w-full text-center text-[12px] leading-[16px]">
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
